<template>
  <footer class="footer">
    <div class="footer__container-top container">
      <!-- <img class="footer__logo" :src="logo" width="220" :alt="item.name" /> -->
      <div class="footer__menu">
        <div class="footer__title">{{ $t('menu') }}</div>
        <template v-for="(navItem, index) in navigation">
          <ActionComponent
            v-if="$path('action.name', navItem) !== $path('name', $route)"
            class="footer__menu-action"
            :class="{ 'footer__menu-action--empty': !navItem.action }"
            v-bind="navItem"
            :key="index"
          />
          <template v-if="navItem.items && navItem.items.length">
            <ActionComponent
              v-for="(nested, ni) in navItem.items"
              class="footer__menu-action footer__menu-action--indent"
              v-bind="nested"
              :key="index + '_' + ni"
            />
          </template>
        </template>
      </div>
      <FooterContent
        v-if="customFooterContent.length"
        :value="customFooterContent"
        class="footer__custom-content"
      />
    </div>

    <div class="container">
      <hr class="footer__hr-bottom" />

      <div class="footer__container-bottom">
        <div class="footer__copyright">
          <div>
            &copy; {{ year }} - {{ $t('pageMadeBy') }}
            <a :href="`https://www.kvass.no?ref=${currentUrl}`" target="_blank">Kvass</a>
          </div>
        </div>
        <div class="footer__links">
          <a :href="`/api/legal/privacy/project/${item.id}`" target="_blank">
            {{ $t('privacyPolicyTitle') }}
          </a>
          <a :href="`/api/legal/cookie/project/${item.id}`" target="_blank">
            {{ $t('cookiePolicyTitle') }}
          </a>
          <a href="#" @click.prevent="editConsents">{{ $t('editConsents') }}</a>
        </div>
        <div class="footer__some" v-if="someCustomField.length !== 0">
          <template v-for="(item, index) in someCustomField">
            <a :key="index" :href="item.url" target="_blank">{{ item.label }}</a>
          </template>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'
import ActionComponent from 'vue-elder-navigation/src/action'
import API from '@/api'
import FooterContent from '@kvass/template-footer-content'
import { GetCustomField, ScrollToAnchor } from '@/utils'

const someMap = {
  facebook_url: 'Facebook',
  instagram_url: 'Instagram',
  linkedin_url: 'LinkedIn',
  twitter_url: 'Twitter',
}

export default {
  props: {
    navigation: Array,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    }
  },
  computed: {
    ...mapState('Root', ['item']),
    customFooterContent() {
      if (!this.item) return

      const content = GetCustomField('footer-content-v2', this.item.customFields) || []
      if (content.some(i => Boolean(this.$path('content', i) || this.$path('image', i)))) {
        return content.map(i => {
          let base = ''
          if (i.image) base = `<img class="mb-4" style="max-width: 230px;" src=${i.image.url}>`
          if (i.content) base = `${base}<div> ${i.content} </div>`
          return base
        })
      }

      return GetCustomField('footer-content', this.item.customFields) || []
    },

    someCustomField() {
      if (!this.item) return
      let items = GetCustomField('social-media', this.item.customFields) || {}

      let newsLetter = {
        url: GetCustomField('newsletter-link', this.item.customFields),
        label: 'Nyhetsbrev',
      }

      return [
        ...Object.keys(items).map(i => {
          return {
            url: items[i],
            label: someMap[i],
          }
        }),
        newsLetter,
      ].filter(i => Boolean(i.url))
    },
    address() {
      return this.item.address
    },
    mapLink() {
      return GetCustomField('map-link', this.item.customFields)
    },
    logo() {
      return API.logo
    },
    currentUrl() {
      return window.location.href
    },
  },
  methods: {
    editConsents() {
      if (window.Kvass) window.Kvass.emit('consent:show')
    },
    navigate() {
      ScrollToAnchor('lead')
    },
  },
  components: {
    ActionComponent,
    FooterContent,
  },
}
</script>

<style lang="scss">
.footer {
  $gap: 4rem;
  background-color: var(--light-grey);
  padding-top: 5rem;
  color: $dark;

  @include respond-below('phone') {
    padding: 1rem 1rem;
  }

  &__container {
    &-top {
      display: flex;
      justify-content: space-between;
      padding-bottom: 3rem;
      gap: $gap;

      @include respond-below('phone') {
        flex-direction: column-reverse;
      }
    }
    &-bottom {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 1rem;
      font-size: 16px;
      padding: 2rem 0rem !important;
    }
  }

  &__custom-content {
    display: flex;
    gap: $gap;
    @include respond-below('phone') {
      flex-wrap: wrap;
    }
  }
  &__logo {
    align-self: center;
    @include respond-below('phone') {
      align-self: flex-start;
      width: 150px;
    }
  }

  h3 {
    margin-bottom: 1rem;
    @include respond-below('phone') {
      margin-bottom: 0;
    }
  }

  a {
    color: $dark;
  }

  p {
    margin: 0;
  }

  &__address {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    a {
      text-decoration: underline;
    }
  }

  &__links {
    display: flex;
    gap: 2rem;
    @include respond-below('phone') {
      flex-direction: column;
      gap: 1rem;
    }
  }

  &__social-icons {
    a {
      margin-right: 0.8rem;
    }
  }

  &__some {
    display: flex;
    gap: 0.5rem;
  }

  &__menu {
    display: flex;
    flex-direction: column;
    justify-content: flex-start !important;

    &-action {
      padding: 0;
      background-color: transparent !important;
      color: inherit;
      font-weight: inherit;

      & span {
        border-bottom: 1px solid $grey;
      }

      & span:hover {
        cursor: pointer;
        border-color: var(--primary);
      }

      & + & {
        margin-top: 0.7rem;
      }

      &--indent {
        margin-left: 0.5rem;
      }
    }
  }

  &__title {
    font-weight: bold;
    display: block;
    margin-bottom: 1rem;
  }
  a {
    text-decoration: none;
    font-size: 16px;
  }
}
</style>
